import { Button } from '@synoptic/ui-kit/button/button.tsx';
import { CheckIcon } from '@synoptic/ui-kit/icons/react/check.tsx';
import { Link } from '@/routes-utils/navigation.tsx';
import { paths } from '@/routes-utils/paths.ts';
import { linkButton, passwordChangedContainer, successBg } from './page.css.ts';
import { cardBody, formHeading } from '@/routes/_auth/page.css';

export const PasswordChanged = () => {
  return (
    <div className={passwordChangedContainer}>
      <div className={successBg}>
        <CheckIcon width={35} height={35} />
      </div>
      <h1 className={formHeading}>Password changed!</h1>
      <p className={cardBody}>Your password has been changed successfully.</p>
      <Button
        className={linkButton}
        size={'large'}
        type="submit"
        variant={'secondary'}
        asChild
      >
        <Link to={paths.makeLogin()}>Back to Synoptic</Link>
      </Button>
    </div>
  );
};
